var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    d: "M12.4853 6.47106L11.071 5.07106L3.99997 12.0711L11.071 19.0711L12.4853 17.6711L7.78963 13L19 13.061V11H7.78963L12.4853 6.47106Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1576E1"
  }))));
};
export default SvgArrowLeft;